import { LinkType } from "src/contexts/_shared/domain/LinkType";
import { AuthRepository } from "../domain/AuthRepository";

type AuthControllerOptions = {
  authRepository: AuthRepository;
};

export enum LoginTypes {
  EMAIL_CODE = "email_code",
  EMAIL_LINK = "email_link",
}

type SendTwoFactorParams = {
  email: string;
  linkType: LinkType;
  linkId: string | null;
  slug: string;
  loginType: LoginTypes;
};

type GetTokenParams = {
  code: string;
  email: string;
  linkType: LinkType;
  linkId: string | null;
};

export class AuthController {
  private readonly authRepository: AuthRepository;

  constructor({ authRepository }: AuthControllerOptions) {
    this.authRepository = authRepository;
  }

  public sendTwoFactor = async ({
    email,
    linkType,
    linkId,
    slug,
    loginType,
  }: SendTwoFactorParams) => {
    return await this.authRepository.sendTwoFactor({
      email,
      linkType: linkType.getValue(),
      linkId,
      slug,
      loginType,
    });
  };

  public async getToken({ code, email, linkType, linkId }: GetTokenParams): Promise<string> {
    return await this.authRepository.getToken({
      code,
      email,
      linkType: linkType.getValue(),
      linkId,
    });
  }
}
